import { Link, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { CheckCircle } from 'lucide-react';

export default function EnrollmentSuccessPage() {
  const { language } = useLanguage();
  const [searchParams] = useSearchParams();
  const enrollmentId = searchParams.get('enrollment');

  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <Navbar />
      <main className="pt-40 pb-20 px-6">
        <div className="max-w-lg mx-auto text-center">
          <div className="card-apple p-10" data-testid="enrollment-success-card">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="h-10 w-10 text-green-600" />
            </div>
            <h1 className="text-3xl font-semibold text-[#1D1D1F] mb-4">
              {language === 'es' ? '¡Inscripción completada!' : 'Enrollment complete!'}
            </h1>
            <p className="text-[#6E6E73] mb-6 text-lg">
              {language === 'es'
                ? 'Tu pago ha sido procesado correctamente. Recibiras un correo de confirmacion con los proximos pasos.'
                : 'Your payment has been processed successfully. You will receive a confirmation email with next steps.'}
            </p>
            {enrollmentId && (
              <p className="text-sm text-[#86868B] mb-6">
                {language === 'es' ? 'Referencia:' : 'Reference:'} {enrollmentId}
              </p>
            )}
            <div className="space-y-3">
              <Link
                to="/"
                className="block w-full py-4 rounded-full font-medium bg-[#E63946] text-white hover:bg-[#D62828] transition-colors"
                data-testid="success-home-btn"
              >
                {language === 'es' ? 'Volver al inicio' : 'Back to home'}
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
